import React, { useState } from "react";
import { Box, Dialog, DialogActions, DialogTitle, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CloseIcon from "assets/images/icons/close-icon.svg"

const useStyles = makeStyles(theme => ({
    root: {
        zIndex: '99999 !important',
        '& .MuiDialog-paper': {
            minWidth: '40%'
        }
    },
    dialogTitle: {
        textTransform: 'uppercase',
        padding: theme.spacing(1, 2),
        '& .MuiTypography-root': {
            display: 'flex',
            justifyContent: 'space-between'
        }
    },
    closeIcon: {
        background: 'none',
        border: 'none',
        cursor: 'pointer'
    },
    formContainer: {
        padding: theme.spacing(2.5, 2.5, 1)
    },
    inputLabel: {
        color: theme.palette.black,
        fontSize: theme.spacing(2),
        '& i': {
            fontWeight: 'bold',
            letterSpacing: theme.spacing(0.15)
        }
    },
    input: {
        color: theme.palette.black,
        fontSize: theme.spacing(2),
        fontFamily: 'inherit',
        border: '1px solid #ccc',
        width: '100%',
        padding: theme.spacing(1),
        '&:focus-visible': {
            outline: 'none'
        }
    },
    submitBtn: {
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1, 2),
        cursor: 'pointer'
    }
}))

export const ChatFeedback = ({ isOpen, onClose, onSubmit }) => {

    const classes = useStyles();
    const { t } = useTranslation()
    const [feedbackText, setFeedbackText] = useState("")

    const handleClose = () => {
        onClose && onClose();
    }

    const hanldeInputChange = (e) => {
        setFeedbackText(e?.target?.value);
    }

    const handleSubmit = () => {
        onSubmit && onSubmit(feedbackText);
        handleClose();
    }

    return <div data-testid="feedbackContainer">
        <Dialog open={isOpen} onClose={handleClose} className={classes.root} data-testid="feedbackDialog">
            <DialogTitle className={`${classes.dialogTitle} feedbackHeading`}>
                <span>{t('please_write_feedback')}</span>
                <button className={classes.closeIcon} data-testid="feedbackCloseBtn" onClick={handleClose}>
                    <img src={CloseIcon} alt="" />
                </button>
            </DialogTitle>
            <Box className={classes.formContainer}>
                <Typography className={classes.inputLabel}>{t('mention_what_didnt_go_right')} <i>({t('optional')})</i></Typography>
                <textarea rows="5" className={classes.input} onChange={hanldeInputChange} data-testid="feedbackInput" />
                <DialogActions>
                    <button
                        className={`${classes.submitBtn} feedbackBtn`}
                        onClick={handleSubmit}
                        data-testid="feedbackSubmitBtn"
                    >
                        {t('submit')}
                    </button>
                </DialogActions>
            </Box>
        </Dialog>
    </div >
}